import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Views } from '../ReservationForClientForm/ReservationForClientForm'

const ReservationFormFooter = ({ view, disableActionButton, onGoBack, onSubmit }) => {
  const { t } = useTranslation(['reservations', 'common'])
  const submitButtonLabels = {
    OccupantInfo: t('reservations:reservationFormFooter.reserveAmenity'),
    UpdateCreditCard: t('reservations:reservationForClientForm.viewHeaders.updateCreditCard'),
    AddCreditCard: t('reservations:reservationForClientForm.viewHeaders.addCreditCard'),
  }
  const submitButtonLabel = submitButtonLabels[view] || t('reservations:reservationFormFooter.next')
  return (
    <div className="reservation-form-footer">
      <button
        onClick={onGoBack}
        className="button button-gray reservation-form-footer__cancel-button auto-width"
      >
        {view === Views.SelectAmenity ? t('common:actions.cancel') : t('common:actions.back')}
      </button>
      {view !== Views.AddNewGuest && (
        <button
          type="submit"
          disabled={disableActionButton}
          onClick={onSubmit}
          className="button button-primary auto-width"
        >
          {submitButtonLabel}
        </button>
      )}
    </div>
  )
}

ReservationFormFooter.propTypes = {
  view: PropTypes.string,
  disableActionButton: PropTypes.bool,
  onGoBack: PropTypes.func,
  onAddGuest: PropTypes.func,
  onSubmit: PropTypes.func,
  disableAddGuestButton: PropTypes.bool,
}

export default ReservationFormFooter
